module.exports = __webpack_public_path__ + "static/media/goldMinus.a627cadf.svg";